import React, { useEffect, useRef } from "react";
import cx from "classnames";
import { useValidation, } from "../../hooks/useValidation";
import { useForm } from "../../hooks/useForm";
import { InputErrorList } from "./InputErrorList";
import "./Input.scss";
function HiddenInputFunction({ value, label, name, scrollToRef, onChange, validators = [], forceValidation = false, validityCallback, }, ref) {
    const inputId = useRef("text_" + Math.random().toString(36).substr(2, 9));
    const [validity, errorMessages, validityClasses, resetValidation] = useValidation(value, validators, forceValidation);
    useForm(inputId.current, validity, value, resetValidation, scrollToRef, errorMessages, label);
    const containerClasses = cx("lysa-ui-input-group", {
        "disable-gutter": !errorMessages || !errorMessages.length,
    });
    const classes = cx("lysa-ui-input", validityClasses);
    useEffect(() => {
        validityCallback === null || validityCallback === void 0 ? void 0 : validityCallback({ validity, validityClasses, resetValidation });
    }, [validity, validityClasses, resetValidation, validityCallback]);
    return (React.createElement("div", { className: containerClasses },
        React.createElement("div", { className: classes },
            React.createElement("input", { value: value, type: "hidden", id: inputId.current, name: name || inputId.current, onChange: (event) => onChange && onChange(event.target.value), ref: ref }),
            React.createElement(InputErrorList, { errorMessages: errorMessages }))));
}
export const HiddenInput = React.forwardRef(HiddenInputFunction);
